export default () => ({
  redirectUrl: '',
  authorizeData: null,
})
